import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";
import "./q-and-a.module.css";

const QandABase = ({ element = {}, type = "", templateQandA = "", templateQuestion = "", templateAnswer = "" }) => {
  const supportedTemplates = type => {
    switch (type) {
      case "q-and-a":
        const { question: questions, answer: answers } = get(element, ["metadata"], "");
        const questionAttributions = get(element, ["metadata", "interviewer", "avatar-url"], "");
        const answerAttributions = get(element, ["metadata", "interviewee", "avatar-url"], "");
        return {
          question: questions,
          answer: answers,
          questionAttribution: questionAttributions,
          answerAttribution: answerAttributions,
          template: templateQandA
        };
      case "question":
        const questionElement = get(element, ["text"], "");
        const questionAttributionElement = get(element, ["metadata", "interviewer", "avatar-url"], "");
        return {
          question: questionElement,
          questionAttribution: questionAttributionElement,
          template: templateQuestion
        };
      case "answer":
        const answerElement = get(element, ["text"], "");
        const answerAttributionElement = get(element, ["metadata", "interviewee", "avatar-url"], "");
        return {
          answer: answerElement,
          answerAttribution: answerAttributionElement,
          template: templateAnswer
        };
    }
  };
  const { question, questionAttribution, answerAttribution, answer, template } = supportedTemplates(type);

  const templateStyle = `wrapper--${template}`;

  const labelQ = `<div class=label>Q</div> ${question}`;

  const supportTemplateData = {
    "q-and-a-element-1": "Q",
    "q-and-a-element-2": `<img src=${questionAttribution} />`,
    "question-element-1": "Q",
    "question-element-2": `<img src=${questionAttribution} />`
  };
  const supportTemplateValue = supportTemplateData[template];
  const supportTemplateElemStr = supportTemplateValue
    ? `<div class=labelQuestion>${supportTemplateValue}</div><span class=hidden></span>`
    : "";
  const questionLabel = `${supportTemplateElemStr}${question}`;
  // EMPTY SPAN FOR EXTRA SPACE
  const answerLabel = `<div class=labelQuestion><img src=${answerAttribution} /></div><span class=hidden></span>
    ${answer}`;

  const questionAttributionType = questionAttribution ? questionLabel : labelQ;
  const answerAttributionType = answerAttribution ? answerLabel : answer;

  return (
    <div styleName={`${templateStyle}`}>
      <div>
        <div styleName="q-element" dangerouslySetInnerHTML={{ __html: questionAttributionType }} />
      </div>
      <div styleName="a-element" dangerouslySetInnerHTML={{ __html: answerAttributionType }} />
    </div>
  );
};

QandABase.propTypes = {
  element: PropTypes.object,
  type: PropTypes.string,
  templateQandA: PropTypes.string,
  templateQuestion: PropTypes.string,
  templateAnswer: PropTypes.string
};

const mapStateToProps = state => ({
  templateQandA: get(
    state,
    ["qt", "config", "theme-attributes", "story-elements", "q-and-a-element"],
    "q-and-a-element-default"
  ),
  templateQuestion: get(
    state,
    ["qt", "config", "theme-attributes", "story-elements", "question-element"],
    "question-element-default"
  ),
  templateAnswer: get(
    state,
    ["qt", "config", "theme-attributes", "story-elements", "answer-element"],
    "answer-element-default"
  )
});

export const QuestionAnswer = connect(mapStateToProps)(QandABase);
